<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Add indicators
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" *ngIf="finishLoading">
    <div class="form-group">
        <label for="searchIndicator"></label>
        <input type="text" id="searchIndicator" class="form-control" placeholder="Buscar indicador"
            (keyup.enter)="searchIndicator($event.target.value)">
    </div>
    <ul class="list-group max-height-indicators p-2" infinite-scroll (scrolled)="scrollIndicators()"
        [scrollWindow]="false">
        <li class="list-group-item" *ngFor="let indicator of indicators">
            <input class="form-check-input me-1" type="checkbox" [checked]="checkStatusCheckbox(indicator)"
                (click)="addOrRemoveIndicator(indicator)">
            {{ indicator.indicator }}
        </li>
    </ul>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>